import React from "react";
import DatePicker from "../../../core/components/DatePicker";
import {useTranslation} from "react-i18next";
import DeviceSelectBox from "../../device/DeviceSelectBox";
import WorklistItemStatusEnum from "../../../enums/WorklistItemStatusEnum";

const {RangePicker} = DatePicker;

export default function WorklistSchedulerFilter({deviceId, setDeviceId, dateRange, setDateRange})
{
    const {t} = useTranslation();

    return (
        <div style={{display: 'flex', gap: '16px', alignItems: 'flex-end'}}>
            <div style={{flex: 1}}>
                <label style={{display: 'block', marginBottom: 8, fontWeight: 'bold'}}>
                    {t('Device')}
                </label>
                <DeviceSelectBox 
                    value={deviceId}
                    onChange={setDeviceId}
                    style={{width: '100%'}}
                />
            </div>

            <div style={{flex: 1}}>
                <label style={{display: 'block', marginBottom: 8, fontWeight: 'bold'}}>
                    {t('DateRange')}
                </label>
                <RangePicker
                    value={dateRange}
                    onChange={setDateRange}
                    format="DD.MM.YYYY"
                    style={{width: '100%'}}
                />
            </div>

            <div style={{marginTop: 24}}>
                <h4 style={{marginBottom: 12}}>{t('Legend')}</h4>
                <div style={{display: 'flex', gap: '16px', flexWrap: 'wrap'}}>
                    {Object.values(WorklistItemStatusEnum).map(status => (
                        <div key={status.value} style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{width: 20, height: 20, backgroundColor: status.color, marginRight: 8}}></div>
                            <span>{t(status.label)}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
